<template>
  <div class="prahndsttls_totals anim-fade-in">
    <PracticeHandsTotalsFilter
      :hasFilters="hasFilters"
      :endpoint="endpoint"
      :callConfig="callConfig"
      :filterConfig="filterConfig"
    >
      <template #content="v">
        <div
          v-if="v.apiCall.error"
          class="prahndsttls_error_message alert-box"
        >
          <div
            class="weight_700"
            v-html="$t('messages.oops_error')"
          ></div>
          <div class="uppercase clr-grey text-small">Error status {{ v.apiCall.status }}</div>
        </div>

        <div
          v-else
          class="d-flex w-100 f-wrap prahndsttls_totals_content"
          style="gap: 1.5rem"
          :class="{ gw_loading: v.apiCall.loading }"
        >
          <PracticeHandsTotalsStats
            :loading="v.apiCall.loading"
            :hasSubtitle="statsHasSubtitle"
            :hasEvStats="statsHasEvStats"
            :hasGtoScoreTrendChart="hasGtoScoreTrendChart"
            :totals="v.totals"
            class="prahndsttls_totals_stats flex-1"
            style="
              --clr-back: var(--clr-stats-back);
              --gap: var(--stats-gap);
              --stats-chart-clr-back: var(--clr-stats-chart-back);
            "
          >
            <router-link
              v-if="$route.name === 'PracticeStats'"
              :to="{ name: 'PracticeHands' }"
              class="gw_btn-v1 gw_btn_text clr-white"
              style="position: absolute; top: 1.5rem; right: 1.5rem"
            >
              <i class="mdi text-large mdi-cards-playing mr-2"></i>
              {{ $t('common.show_hands') }}
            </router-link>
            <template #title>
              <slot name="stats_title"> </slot>
            </template>
          </PracticeHandsTotalsStats>
          <PracticeHandsTotalsTypes
            v-if="hasTypes"
            class="flex-1"
            :types="v.types"
          />
        </div>
      </template>
    </PracticeHandsTotalsFilter>
  </div>
</template>

<script>
import PracticeHandsTotalsFilter from '@/components/PracticeHandsTotals/PracticeHandsTotalsFilter'
import PracticeHandsTotalsStats from '@/components/PracticeHandsTotals/PracticeHandsTotalsStats'
import PracticeHandsTotalsTypes from '@/components/PracticeHandsTotals/PracticeHandsTotalsTypes'

export default {
  name: 'PracticeHandsTotals',

  components: {
    PracticeHandsTotalsTypes,
    PracticeHandsTotalsFilter,
    PracticeHandsTotalsStats,
  },
  props: {
    hasFilters: { type: Boolean, default: true },
    hasTypes: { type: Boolean, default: true },
    statsHasEvStats: { type: Boolean, default: true },
    statsHasSubtitle: { type: Boolean, default: true },
    hasGtoScoreTrendChart: { type: Boolean, default: true },
    filterConfig: Object,
    endpoint: { default: () => 'poker/practice/practice-hands/totals/' },
    callConfig: {
      default: () => ({
        apiVersion: 'v1',
      }),
    },
  },
  data() {
    return {}
  },
  created() {},
}
</script>

<style lang="scss" scoped>
.prahndsttls_totals {
  --clr-stats-back: var(--clr-black-1);
  --clr-stats-chart-back: var(--clr-black-3);
  --stats-gap: 2rem;
  width: 100%;
}
.prahndsttls_totals_stats-inline {
  .prahndsttls_totals_stats {
    flex-direction: row !important;
    flex-wrap: wrap;
  }
}

@media (max-width: 1023px) {
  .prahndsttls_totals {
    &_content {
      flex-direction: column;
      padding-bottom: 3rem;
    }
  }
}
</style>
